import React from 'react';
import DashboardOverview from '../components/dashboard/DashboardOverview';

function DashboardScreen() {
  return <DashboardOverview />;
}

export default DashboardScreen;
